import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex } from 'antd';
import React, { useState } from 'react';

import { PREFIX } from '@app/constants';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';

import { useEditSalesFunnelPageHeaderEffects } from '@pages/SalesFunnels/EditSalesFunnel/hooks/useEditSalesFunnelPageHeaderEffects';

import { SalesFunnelSettingsModal } from '@pages/SalesFunnels/EditSalesFunnel/components/SalesFunnelSettingsModal';

import '@pages/SalesFunnels/EditSalesFunnel/styles/EditSalesFunnelPageHeader.desktop.scss';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export const EditSalesFunnelPageHeader: React.FC = () => {
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const { currentSalesFunnel } = useEditSalesFunnelPageHeaderEffects();

  const { isMobile } = useWindowSize();

  const {
    userAccessRights: {
      SalesFunnels: { IsFunnelEdit },
    },
  } = useNewUserAccessRights();

  return (
    <div className={`${PREFIX}edit-sales-funnel-page-header`}>
      {currentSalesFunnel && IsFunnelEdit ? (
        <Flex gap="small" align="baseline">
          <Button type="primary" onClick={() => setIsSettingsModalOpen(true)}>
            {isMobile ? (
              <FontAwesomeIcon
                icon={'fa-solid fa-gear' as IconProp}
                size="lg"
                className="icon"
              />
            ) : (
              'Настройки'
            )}
          </Button>
        </Flex>
      ) : (
        ''
      )}

      <SalesFunnelSettingsModal
        isModalOpen={isSettingsModalOpen}
        setIsModalOpen={setIsSettingsModalOpen}
        currentSalesFunnel={currentSalesFunnel}
      />
    </div>
  );
};
